import { render } from "./FamilyTree.vue?vue&type=template&id=195a5d5e&scoped=true"
import script from "./FamilyTree.vue?vue&type=script&lang=js"
export * from "./FamilyTree.vue?vue&type=script&lang=js"

import "./FamilyTree.vue?vue&type=style&index=0&id=195a5d5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195a5d5e"]])

export default __exports__